{
  "label": "gruppo utente",
  "button": {
    "delete": "Eliminare il gruppo",
    "create": "Nuovo gruppo"
  },
  "confirmDelete": {
    "title": "Eliminazione di un gruppo",
    "description": "Il gruppo selezionato \"{userGroupName}\" sarà eliminato"
  },
  "cannotDelete": {
    "title": "Impossibile eliminare un gruppo",
    "description": "Il gruppo selezionato \"{userGroupName}\" è associato a {usersCount} utenti"
  },
  "empty": "Nessun gruppo trovato",
  "search": "Ricerca per nome",
  "create": {
    "title": "Nuovo gruppo",
    "confirm": {
      "title": "Creazione del gruppo"
    }
  },
  "update": {
    "title": "Modifica gruppo",
    "confirm": {
      "title": "Modifica il gruppo"
    }
  },
  "confirm": {
    "message": "Confermi l'annullamento dell'operazione? Tutti i dati non salvati andranno persi."
  },
  "information": "Informazioni sul gruppo",
  "name": "Nome del gruppo",
  "sector": {
    "title": "Settori"
  },
  "sectors": {
    "label": "Settori collegati al gruppo"
  },
  "addUsers": {
    "title": "Aggiungi utenti"
  }
}
